import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CContainer,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { successAlert } from "../utils/messages";

import { getRoutePath } from "../../routes";

import PrizeRegisterForm from "./PrizeRegisterForm";
import PrizeLog, { newPrizeLog } from "../../models/prize-log";

const PrizeRegisterView = () => {

  const [registerOperation,] = useState<PrizeLog>(newPrizeLog());
  
  const history = useHistory();


  const onRegisterSuccess = () => {
    successAlert("Operación registrada con exito!");
    history.push(getRoutePath("dashboard"));
  };

  return (
    <>
      <CContainer fluid>
        <CRow>
          <CCol lg="12">
            <CCard>
              <CCardHeader className="d-flex flex-row mb-3">
                <div className="p-2 ">
                  <h3>
                    {"REGISTRO DE PREMIOS"}
                  </h3>
                </div>
                
              </CCardHeader>
              <CCardBody>
                <PrizeRegisterForm initialOperation={registerOperation} onSuccess={onRegisterSuccess}></PrizeRegisterForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </>
  );
};

export default PrizeRegisterView;

